/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManagedUserPermissionsPayload } from './ManagedUserPermissionsPayload';
export type CreateManagedUserPayload = {
    firstName: string;
    lastName: string;
    email: string;
    title?: string | null;
    gender?: CreateManagedUserPayload.gender;
    therapistName: string;
    permissions?: ManagedUserPermissionsPayload;
};
export namespace CreateManagedUserPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

